<!-- Query Builder -->
<app-kv-ext-search
  *ngIf="showExtSearch && extSearchConfig"
  [query]="extSearchQuery"
  [config]="extSearchConfig"
  [openedAccordion]="openExtSearch"
  (extSearchReq)="sendExtSearchQuery($event)"
></app-kv-ext-search>

<div *ngIf="showMeReport" id="viewerContent"></div>

<div [ngSwitch]="layout" style="height: 100%"  *ngIf="srvCalendar">

  <p-table *ngSwitchCase="standardLayout" #dt
           [columns]="cols" [value]="filteredData"
           [rowsPerPageOptions]="defaultRowsPerPageOptions"
           [paginator]="paginationType != noPagination && filteredData"
           [rows]="filter.limit"
           [totalRecords]="totalRecords"
           [lazy]="paginationType === 2"
           (onPage)="onPageChange($event)"
           (onSort)="onSortData($event)"
  >
    <ng-template pTemplate="caption">
      <div class="kontable-head" *ngIf="title" style="font-size: 1.17em;display: block; height: 50px;">
        <h3 style="font-size: 1.17em;text-align:center;width: 90%;margin: 0;padding-top: 15px;">{{title}}</h3>
        <div class="kontable-head-buttons">
          <ng-container *ngTemplateOutlet="toolbarCustomButtons"></ng-container>

          <!-- button add-->
          <button
          *ngIf="showAddButton"
          id="add"
          name="add"
          pButton type="button"
          class="k-generic-btn"
          icon="fa fa-plus-circle"
          iconPos="left"
          label="{{ 'common.add' | translate }}"
          (click)="rowEvent($event, null, 'add')"></button>

          <!-- button report -->
          <button
          *ngIf="showReport"
          id="showReport"
          name="showReport"
          pButton type="button"
          class="k-generic-btn"
          icon="fa fa-file"
          iconPos="left"
          label="{{ 'kontable.viewReport' | translate }}"
          (click)="onClickViewReport()"></button>

          <!-- button download excel -->
          <button
          *ngIf="showDownloadExcelBtn"
          pButton
          type="button"
          class="k-generic-btn"
          icon="fa fa-file-excel-o"
          iconPos="left"
          label="{{ 'kontable.downloadExcel' | translate }}"
          (click)="downloadExcel()"></button>

          <!-- button conferma prenotazione -->
          <button
          *ngIf="showConfirmGiftsBtn"
          pButton
          type="button"
          class="k-generic-btn"
          icon="fa fa-file"
          iconPos="left"
          label="{{ 'reservations.confirmGifts' | translate }}"
          (click)="onConfirmGifts.emit()"></button>

          <!-- button homing -->
          <span *ngIf="showCardHomingBtns">
            <button
            pButton
            type="button"
            class="k-generic-btn"
            label="{{ 'kontable.card_homing_by_store' | translate }}"
            (click)="cardHomingByStore()">
            </button>

            <button
            pButton
            type="button"
            class="k-generic-btn"
            label="{{ 'kontable.card_homing_by_range' | translate }}"
            (click)="cardHomingByRange()">
            </button>
          </span>

        </div>

      </div>
      <div *ngIf="!showExtSearch">
        <i class="fa fa-search" style="margin:4px 4px 0 0" *ngIf="paginationType !== this.serverPagination && this.showGlobalFilter"></i>
        <input *ngIf="paginationType !== this.serverPagination && this.showGlobalFilter"
               type="text" pInputText size="50" placeholder="{{ 'globalFilerPlaceholder' | translate }}"
               [ngModel]="globalFilter" (input)="globalFilterChange($event.target.value)" style="width:auto">
        <p-checkbox *ngIf="showIncludeDeleted" label="{{ 'kontable.includeDeletedFilter' | translate }}"
                    [(ngModel)]="includeDeleted" (onChange)="internalIncludeDeletedChanged($event)"></p-checkbox>
      </div>
    </ng-template>
    <ng-template pTemplate="header" let-columns>

      <tr class="kontable-tr">
        <th *ngFor="let col of columns" class="kontable-th field-{{col.field}}" [attr.data-testid]="col.field">
          <div *ngIf="!columnFiltersEnabled && !showExtSearch" class="kontable-col-title" [ngStyle]="{'justify-content': col.textAlignment == 'right' ? 'flex-end' : col.textAlignment}">
            <span>{{ col.title | translate }}</span>
          </div>

          <div *ngIf="(columnFiltersEnabled || showExtSearch) && col.sortable" class="kontable-col-title" [pSortableColumn]="col.field" [ngStyle]="{'justify-content': col.textAlignment == 'right' ? 'flex-end' : col.textAlignment}">
            <span>{{ col.title | translate }}</span>
            <p-sortIcon *ngIf="col.sortable" [field]="col.field" ariaLabel="{{ 'kontable.activateToSort' | translate }}" ariaLabelDesc="{{ 'kontable.activateToSortDescending' | translate }}"
                        ariaLabelAsc="{{ 'kontable.activateToSortAscending' | translate }}"></p-sortIcon>
          </div>

          <div *ngIf="(columnFiltersEnabled || showExtSearch) && !col.sortable" class="kontable-col-title" [ngStyle]="{'justify-content': col.textAlignment == 'right' ? 'flex-end' : col.textAlignment}">
            <span>{{ col.title | translate }}</span>
          </div>

          <div *ngIf="col.searchable && columnFiltersEnabled">
            <div [ngSwitch]="col.filterType">
              <input *ngSwitchCase="textFilter" pInputText type="text" (input)="updateTableFilter(col.field, $event.target.value, 'contains', col.filterChars)" [(ngModel)]="filter.search[col.field]" [maxlength]="col.maxFilterChars">
              <input *ngSwitchCase="numberFilter" pInputText type="number" min="0" (input)="updateTableFilter(col.field, $event.target.value, 'contains', col.filterChars)" [(ngModel)]="filter.search[col.field]">
              <p-dropdown *ngSwitchCase="selectFilter" [options]="col.filterOptions.values" [style]="{'width':'100%'}"  (onChange)="updateTableFilter(col.field, $event.value, 'equals', col.filterChars)" [(ngModel)]="filter.search[col.field]"></p-dropdown>
              <p-multiSelect *ngSwitchCase="multiselectFilter" [options]="col.filterOptions.values" defaultLabel="" (onChange)="updateTableFilter(col.field, $event.value, 'in', col.filterChars)" [(ngModel)]="filter.search[col.field]"></p-multiSelect>
              <!-- Filtro Data -->
              <div *ngSwitchCase="dateFilter">
                <p-calendar
                  *ngIf="srvCalendar.pcalendarTranslate"
                  class="calendarKontable"
                  dataType="date"
                  dateFormat="{{srvCalendar.pcalendarTranslate.dateFormat}}"
                  [(ngModel)]="filter.search[col.field]"
                  [monthNavigator]="true"
                  [yearNavigator]="true"
                  [locale]="srvCalendar.pcalendarTranslate"
                  [yearRange]="'1900:2099'"
                  (onSelect)="updateTableFilter(col.field, convertDate($event), 'equals', col.filterChars)"
                  (onClearClick)="updateTableFilter(col.field, $event.value, 'equals', col.filterChars)"
                  [inputStyle]="{'width':'100%', 'height':'26px', 'border-color':'#fec55c'}"
                  [readonlyInput]="true"
                  showClear="true"
                  showButtonBar="true">
                </p-calendar>
              </div>
              <span *ngSwitchCase="customFilter">
                <ng-container *ngTemplateOutlet="col.filterTemplate; context: {$implicit:col}"></ng-container>
              </span>
              <span *ngSwitchDefault>&nbsp;</span>
            </div>
          </div>

        </th>
        <th id="filter-buttons-container" *ngIf="showResetFiltersBtn || !filterBySingleColumn || showRowButtons">

          <!-- Button Pulisci Filtri -->
          <button
            *ngIf="showResetFiltersBtn"
            id="refreshFilter"
            data-testid="refreshFilter"
            name="refreshFilter"
            pButton
            type="button"
            class="k-generic-btn"
            (click)="clearFilters()"
            icon="fa fa-refresh"
            iconPos="center"
            pTooltip="{{ 'kontable.clearFilters' | translate }}">
          </button>

          <!-- Button Applica Filtri -->
          <button
            *ngIf="!filterBySingleColumn"
            pButton
            data-testid="applyFilter"
            type="button"
            class="k-generic-btn"
            (click)="updateTableFilter(null, null, null, 1, 1000, true)"
            icon="fa fa-filter"
            iconPos="center"
            pTooltip="{{ 'kontable.applyFilters' | translate }}">
          </button>

        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-row let-columns="columns" let-index="rowIndex">
      <tr
      [ngClass]="{'odd-row':alternateRows && index%2==0}"
      class="kontable-tr
        {{ row.flg_state && row.flg_state == '1' ? 'deleted-row' : '' }}
        {{ row.flg_state && row.flg_state == '2' ? 'status2-row' : '' }}
        {{ row.flg_state && row.flg_state == '3' ? 'status3-row' : '' }}
        {{ row.customerCardState && row.customerCardState == '7' ? 'customerCardState7-row' : '' }}
        {{ row.cardLinkStatus && row.cardLinkStatus == '7' ? 'status-row' : '' }}">
        <td *ngFor="let col of columns" [ngStyle]="{'text-align': col.textAlignment ? col.textAlignment : 'left'}">
          <span *ngIf="col.bodyTemplate">
            <ng-container *ngTemplateOutlet="col.bodyTemplate; context: {$implicit:row, value: row[col.field]}"></ng-container>
          </span>
          <span *ngIf="!col.bodyTemplate">
            <span *ngIf="col.type && col.type == 'date'">
              <span *ngIf="!srvCalendar.checkDateFormat(row[col.field])">{{ row[col.field] | date: srvCalendar.pcalendarTranslate.dateFormatFilter }}</span>
              <span *ngIf="srvCalendar.checkDateFormat(row[col.field])">{{ row[col.field] }}</span>
            </span>
            <span *ngIf="col.type && col.type !== '' && col.type !== 'date'">{{format(row[col.field], col.type)}}</span>
          </span>
        </td>

        <!-- Button row table -->
        <td class="btn-list" *ngIf="showRowButtons">

          <p-button pTooltip="{{ 'common.view' | translate }}" icon="fa fas fa-eye" *ngIf="getPermissions().view && showDetailsButton" styleClass="ui-button-info" (onClick)="rowEvent($event, row, 'details')"></p-button>

          <!-- Button modify -->
          <p-button pTooltip="{{ 'common.edit' | translate }}" icon="fa fas fa-edit" *ngIf="getPermissions().edit && showEditButton && (!row.flg_state || row.flg_state === '0')" styleClass="ui-button-info" (onClick)="rowEvent($event, row, 'edit')"></p-button>

          <!-- Button cancel -->
          <p-button pTooltip="{{ 'common.delete' | translate }}" icon="fa far fa-trash" *ngIf="getPermissions().delete && showDeleteButton && (!row.flg_state || row.flg_state === '0')" styleClass="ui-button-info" (onClick)="rowEvent($event, row, 'confirm-remove')"></p-button>

          <!-- Button recover -->
          <p-button pTooltip="{{ 'common.undo' | translate }}" icon="fa fas fa-undo" *ngIf="getPermissions().delete && showRecoverButton && row.flg_state && row.flg_state !== '0'" styleClass="ui-button-info" (onClick)="rowEvent($event, row, 'confirm-recover')"></p-button>

          <p-button pTooltip="{{ 'common.rolesManagement' | translate }}" icon="fa fas fa-user-plus" *ngIf="showRolesButton" styleClass="ui-button-info" (onClick)="rowEvent($event, row, 'manage-roles')"></p-button>

          <ng-container *ngTemplateOutlet="additionalRowCommands; context: {$implicit:row}" >
          </ng-container>

          <!-- Button info -->
          <p-button pTooltip="{{ 'common.info' | translate }}" icon="fa fas fa-info" *ngIf="showInfoButton" styleClass="ui-button-info" (onClick)="rowEvent($event, row, 'info')"></p-button>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="paginatorleft" let-state>
      <p data-testid="tableTotalRecords" class="paginator-total-records" *ngIf="showTotalRecord">{{ 'kontable.total_records' | translate }}: {{totalRecords}}</p>
    </ng-template>
    <ng-template pTemplate="paginatorright" let-state>
      <p data-testid="totalPages" class="paginator-total-records" *ngIf="showTotalPages">{{ 'kontable.total_pages' | translate }}: {{totalPages}}</p>
    </ng-template>
  </p-table>

  <p-dialog
    *ngIf="showInfo"
    [width]="500"
    [height]="200"
    [(visible)]="showInfo"
    header="{{ 'kontable.recordInfoTitle' | translate }}"
    [responsive]="true"
    showEffect="fade"
    [modal]="true">

    <ng-container *ngTemplateOutlet="infoDialogBodyTemplate ? infoDialogBodyTemplate: defaultInfoContent">
    </ng-container>

    <div class="ui-dialog-footer">
      <p-button id="closeInfo" name="closeInfo" styleClass="slim blue-button" label="Close" (onClick)="showInfo = false;"></p-button>
    </div>
  </p-dialog>

  <ng-template #defaultInfoContent>
    <div>

      <div class="ui-g ui-fluid" *ngIf="currentInfo && currentInfo.userInsertInfo">
        <div class="ui-g-6">
          <label>{{ 'kontable.insertedBy' | translate }}</label>
          <span>{{ currentInfo.userInsertInfo.login }}</span>
        </div>
        <div class="ui-g-6">
          <label>{{ 'kontable.insertedOn' | translate }}</label>
          <span>{{ currentInfo.userInsertInfo.insert_timestamp | date :'dd/MM/yyyy hh:mm:ss' }}</span>
        </div>
      </div>

      <div class="ui-g ui-fluid" *ngIf="currentInfo && currentInfo.userUpdateInfo">
        <div class="ui-g-6">
          <label>{{ 'kontable.updatedBy' | translate }}</label>
          <span>{{ currentInfo.userUpdateInfo.login }}</span>
        </div>
        <div class="ui-g-6">
          <label>{{ 'kontable.updatedOn' | translate }}</label>
          <span>{{ currentInfo.userUpdateInfo.update_timestamp | date :'dd/MM/yyyy hh:mm:ss' }}</span>
        </div>
      </div>

      <div class="ui-g ui-fluid" *ngIf="currentInfo && currentInfo.userDeleteInfo">
        <div class="ui-g-6">
          <label>{{ 'kontable.deletedBy' | translate }}</label>
          <span>{{ currentInfo.userDeleteInfo.login }}</span>
        </div>
        <div class="ui-g-6">
          <label>{{ 'kontable.deletedOn' | translate }}</label>
          <span>{{ currentInfo.userDeleteInfo.delete_timestamp | date :'dd/MM/yyyy hh:mm:ss' }}</span>
        </div>
      </div>

      <div class="ui-g ui-fluid" *ngIf="!currentInfo">
        <div class="ui-g-6">
          <label>{{ 'kontable.insertedBy' | translate }}</label>
          <span>{{ 'kontable.unknownUser' | translate }}</span>
        </div>
      </div>

    </div>
  </ng-template>

</div>




// WEBPACK FOOTER //
// ./src/app/modules/UIKit/components/kontablenew/kontablenew.component.html